export const summarizeMatches = (
  items: ReadonlyArray<{ readonly target?: any }>,
): string => {
  const total = items.length
  const matched = items.filter(
    (item) => item.target !== null && item.target !== undefined,
  ).length

  return `${matched} of ${total}`
}
